module.exports = __webpack_public_path__ + "img/white-logo-210.6b92d436.jpeg";